/**
 * TopBar — 56px header with breadcrumb (left) + inert action stubs (right).
 *   - Ask AI and Support are "Coming soon" placeholders.
 *   - Avatar is a green-600 circle with the user's initial.
 */
import { useRouterState } from "@tanstack/react-router";
import { Question, Sparkle } from "./icons";
import { buildNavSections } from "./nav-config";

function titleCase(path: string): string {
	if (path === "/" || path === "") return "Overview";
	return path
		.replace(/^\/+|\/+$/g, "")
		.split(/[-/.]/)
		.filter(Boolean)
		.map((w) => w[0].toUpperCase() + w.slice(1))
		.join(" ");
}

function resolveLabel(pathname: string): string {
	const sections = buildNavSections();
	for (const sec of sections) {
		for (const it of sec.items) {
			if (it.to === pathname) return it.label;
		}
	}
	// Fallback: parent match (nested paths)
	for (const sec of sections) {
		for (const it of sec.items) {
			if (it.to !== "/" && pathname.startsWith(`${it.to}/`)) return it.label;
		}
	}
	return titleCase(pathname);
}

export function TopBar() {
	const pathname = useRouterState({ select: (s) => s.location.pathname });
	const label = resolveLabel(pathname);

	return (
		<header className="h-14 bg-white border-b border-zinc-200 flex items-center justify-between px-6">
			<div className="flex items-center text-[13px] text-zinc-500">
				<span className="text-zinc-400">Home</span>
				<span className="mx-2 text-zinc-300">/</span>
				<span className="text-zinc-900 font-medium">{label}</span>
			</div>

			<div className="flex items-center gap-2">
				<button
					type="button"
					className="cf-nav-item"
					title="Coming soon"
					onClick={(e) => e.preventDefault()}
				>
					<Sparkle className="w-4 h-4 text-zinc-500" />
					<span>Ask AI</span>
				</button>
				<button
					type="button"
					className="cf-nav-item"
					title="Coming soon"
					onClick={(e) => e.preventDefault()}
				>
					<Question className="w-4 h-4 text-zinc-500" />
					<span>Support</span>
				</button>
				<div className="w-8 h-8 rounded-full bg-green-600 text-white font-semibold flex items-center justify-center text-xs">
					N
				</div>
			</div>
		</header>
	);
}
